export enum FieldNames {
    id = 'id',
    /** Export */
    startDate = 'startDate',
    endDate = 'endDate',
    /** Configuration */
    transferAccountCode = 'transferAccountCode',
    folioBalanceAccountCode = 'folioBalanceAccountCode',
    depositAccountCode = 'depositAccountCode',
    accountReceivableAccountCode = 'accountReceivableAccountCode',
    companyCode = 'companyCode',
    distinctionTransaction = 'distinctionTransaction',
    accountReceivableExportType = 'accountReceivableExportType',
    taxAccountMappings = 'taxAccountMappings',
    /** TaxAccountMapping  */
    taxCode = 'taxCode',
    externalCode = 'externalCode',
    exportType = 'exportType',
    revenueFallbackAccountCode = 'revenueFallbackAccountCode',
    paymentFallbackAccountCode = 'paymentFallbackAccountCode',
    outletBillsFallbackAccountCode = 'outletBillsFallbackAccountCode',
    otherFallbackAccountCode = 'otherFallbackAccountCode',
}
